import React, { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import Footer from "../Footer";
import { PUBLIC_URL } from "../../app.config";
import { useMenu } from "../../context/menuContext";
import $ from 'jquery';

export const DashboardLayout = ({ children }) => {
  // const dispatch = useDispatch();
  // const navigate = useNavigate();
  const location = useLocation();
  const path = '/' + location?.pathname?.split('/')?.[1]
  const path1 = '/' + location?.pathname?.split('/')?.[2]
  const elementRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const { menuState, toggleMenu } = useMenu();
  
  return (
    <>
      {/* {path === '/login' || path === '/sign-up' || path === '/lock-screen' || path === '/complete-profile' || path === '/worksheet' || localStorage.getItem("PisLogin") === null || localStorage.getItem("PisLogin") === false ? <>
        {children}
        <Outlet />
      </>
        : */}
        <>
          <div id="wrapper">
            <Navbar elementRef={elementRef} setVisible={setVisible} visible={visible} />
            <Sidebar elementRef={elementRef} visible={visible} />
            <div className={`content-page ${
          menuState === "hide" ? "custLeftsidebar" : ""
        }`}>
              {children}
              <Outlet />
              <Footer />
            </div>
          </div>
          <div className="offcanvas offcanvas-end" tabIndex="-1" id="theme-settings-offcanvas">
            <div className="d-flex align-items-center bg-primary p-3 offcanvas-header">
              <h5 className="text-white m-0">Theme Settings</h5>
              <button type="button" className="btn-close btn-close-white ms-auto" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>

            <div className="offcanvas-body p-0">
              <div data-simplebar className="h-100">
                <div className="p-3">
                  <h5 className="mb-3 fs-16 fw-bold">Color Scheme</h5>

                  <div className="row">
                    <div className="col-4">
                      <div className="form-check form-switch card-switch mb-1">
                        <input className="form-check-input" type="checkbox" name="data-bs-theme" id="layout-color-light" value="light" />
                        <label className="form-check-label" htmlFor="layout-color-light">
                          <img src={PUBLIC_URL + "/assets/images/layouts/light.png"} alt="" className="img-fluid" />
                        </label>
                      </div>
                      <h5 className="font-14 text-center text-muted mt-2">Light</h5>
                    </div>

                    <div className="col-4">
                      <div className="form-check form-switch card-switch mb-1">
                        <input className="form-check-input" type="checkbox" name="data-bs-theme" id="layout-color-dark" value="dark" />
                        <label className="form-check-label" htmlFor="layout-color-dark">
                          <img src={PUBLIC_URL + "/assets/images/layouts/dark.png"} alt="" className="img-fluid" />
                        </label>
                      </div>
                      <h5 className="font-14 text-center text-muted mt-2">Dark</h5>
                    </div>
                  </div>

                  <div id="layout-width">
                    <h5 className="my-3 fs-16 fw-bold">Layout Mode</h5>

                    <div className="row">
                      <div className="col-4">
                        <div className="form-check form-switch card-switch mb-1">
                          <input className="form-check-input" type="checkbox" name="data-layout-mode" id="layout-mode-fluid" value="fluid" />
                          <label className="form-check-label" htmlFor="layout-mode-fluid">
                            <img src={PUBLIC_URL + "/assets/images/layouts/light.png"} alt="" className="img-fluid" />
                          </label>
                        </div>
                        <h5 className="font-14 text-center text-muted mt-2">Fluid</h5>
                      </div>

                      <div className="col-4">
                        <div id="layout-boxed">
                          <div className="form-check form-switch card-switch mb-1">
                            <input className="form-check-input" type="checkbox" name="data-layout-mode" id="layout-mode-boxed" value="boxed" />
                            <label className="form-check-label" htmlFor="layout-mode-boxed">
                              <img src={PUBLIC_URL + "/assets/images/layouts/boxed.png"} alt="" className="img-fluid" />
                            </label>
                          </div>
                          <h5 className="font-14 text-center text-muted mt-2">Boxed</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <h5 className="my-3 fs-16 fw-bold">Topbar Color</h5>

                  <div className="row">
                    <div className="col-4">
                      <div className="form-check form-switch card-switch mb-1">
                        <input className="form-check-input" type="checkbox" name="data-topbar-color" id="topbar-color-light" value="light" />
                        <label className="form-check-label" htmlFor="topbar-color-light">
                          <img src={PUBLIC_URL + "/assets/images/layouts/light.png"} alt="" className="img-fluid" />
                        </label>
                      </div>
                      <h5 className="font-14 text-center text-muted mt-2">Light</h5>
                    </div>

                    <div className="col-4">
                      <div className="form-check form-switch card-switch mb-1">
                        <input className="form-check-input" type="checkbox" name="data-topbar-color" id="topbar-color-dark" value="dark" />
                        <label className="form-check-label" htmlFor="topbar-color-dark">
                          <img src={PUBLIC_URL + "/assets/images/layouts/topbar-dark.png"} alt="" className="img-fluid" />
                        </label>
                      </div>
                      <h5 className="font-14 text-center text-muted mt-2">Dark</h5>
                    </div>
                  </div>

                  <div>
                    <h5 className="my-3 fs-16 fw-bold">Menu Color</h5>

                    <div className="row">
                      <div className="col-4">
                        <div className="form-check form-switch card-switch mb-1">
                          <input className="form-check-input" type="checkbox" name="data-menu-color" id="leftbar-color-light" value="light" />
                          <label className="form-check-label" htmlFor="leftbar-color-light">
                            <img src={PUBLIC_URL + "/assets/images/layouts/sidebar-light.png"} alt="" className="img-fluid" />
                          </label>
                        </div>
                        <h5 className="font-14 text-center text-muted mt-2">Light</h5>
                      </div>

                      <div className="col-4">
                        <div className="form-check form-switch card-switch mb-1">
                          <input className="form-check-input" type="checkbox" name="data-menu-color" id="leftbar-color-dark" value="dark" />
                          <label className="form-check-label" htmlFor="leftbar-color-dark">
                            <img src={PUBLIC_URL + "/assets/images/layouts/light.png"} alt="" className="img-fluid" />
                          </label>
                        </div>
                        <h5 className="font-14 text-center text-muted mt-2">Dark</h5>
                      </div>
                    </div>
                  </div>

                  <div id="sidebar-size">
                    <h5 className="my-3 fs-16 fw-bold">Sidebar Size</h5>

                    <div className="row">
                      <div className="col-4">
                        <div className="form-check form-switch card-switch mb-1">
                          <input className="form-check-input" type="checkbox" name="data-sidenav-size" id="leftbar-size-default" value="default" />
                          <label className="form-check-label" htmlFor="leftbar-size-default">
                            <img src={PUBLIC_URL + "/assets/images/layouts/light.png"} alt="" className="img-fluid" />
                          </label>
                        </div>
                        <h5 className="font-14 text-center text-muted mt-2">Default</h5>
                      </div>

                      <div className="col-4">
                        <div className="form-check form-switch card-switch mb-1">
                          <input className="form-check-input" type="checkbox" name="data-sidenav-size" id="leftbar-size-compact" value="compact" />
                          <label className="form-check-label" htmlFor="leftbar-size-compact">
                            <img src={PUBLIC_URL + "/assets/images/layouts/compact.png"} alt="" className="img-fluid" />
                          </label>
                        </div>
                        <h5 className="font-14 text-center text-muted mt-2">Compact</h5>
                      </div>

                      <div className="col-4">
                        <div className="form-check form-switch card-switch mb-1">
                          <input className="form-check-input" type="checkbox" name="data-sidenav-size" id="leftbar-size-small" value="condensed" />
                          <label className="form-check-label" htmlFor="leftbar-size-small">
                            <img src={PUBLIC_URL + "/assets/images/layouts/sm.png"} alt="" className="img-fluid" />
                          </label>
                        </div>
                        <h5 className="font-14 text-center text-muted mt-2">Condensed</h5>
                      </div>


                      <div className="col-4">
                        <div className="form-check form-switch card-switch mb-1">
                          <input className="form-check-input" type="checkbox" name="data-sidenav-size" id="leftbar-size-full" value="full" />
                          <label className="form-check-label" htmlFor="leftbar-size-full">
                            <img src={PUBLIC_URL + "/assets/images/layouts/full.png"} alt="" className="img-fluid" />
                          </label>
                        </div>
                        <h5 className="font-14 text-center text-muted mt-2">Full Layout</h5>
                      </div>
                    </div>
                  </div>

                  <div id="layout-position">
                    <h5 className="my-3 fs-16 fw-bold">Layout Position</h5>

                    <div className="btn-group checkbox" role="group">
                      <input type="radio" className="btn-check" name="data-layout-position" id="layout-position-fixed" value="fixed" />
                      <label className="btn btn-soft-primary w-sm" htmlFor="layout-position-fixed">Fixed</label>

                      <input type="radio" className="btn-check" name="data-layout-position" id="layout-position-scrollable" value="scrollable" />
                      <label className="btn btn-soft-primary w-sm ms-0" htmlFor="layout-position-scrollable">Scrollable</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="offcanvas-footer border-top p-3 text-center">
              <div className="row">
                <div className="col-md-12">
                  <button type="button" className="btn btn-light w-100 buttonColor" id="reset-layout">Reset</button>
                </div>
              </div>
            </div>
          </div>
        </>
      {/* } */}


    </>
  );
};